import { Text } from 'native-base';
import React from 'react';

export interface AboutTextProps {
  fontSize?: number;
  textAlign?: 'left' | 'center' | 'right';
}

export const AboutText: React.FC<AboutTextProps> = ({ fontSize, textAlign }) => {
  return (
    <Text fontSize={fontSize} textAlign={textAlign}>
      Rock The Street, Wall Street empowers high school girls and university women by bringing the M in STEM to life
      through a focus on Financial & Investment fundamentals. We provide industry access and guidance to our students
      and alumnae supporting their journey from classrooms to careers while fostering expanded participation in the
      capital markets.
    </Text>
  );
};
